module.exports = __webpack_public_path__ + "img/phone.9485085e.png";